import { ADD_CALLABLE_ASSOCIATION } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
export default function addCallableAssociation(callableAssociation) {
  return callingAPIMethodWithQueue(ADD_CALLABLE_ASSOCIATION, callableAssociation);
}